import { render } from "./BlockName.vue?vue&type=template&id=5f4ace88&scoped=true"
import script from "./BlockName.vue?vue&type=script&lang=js"
export * from "./BlockName.vue?vue&type=script&lang=js"

import "./BlockName.vue?vue&type=style&index=0&id=5f4ace88&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4ace88"]])

export default __exports__